<template>
  <div class="modal-backdrop">
    <div class="popup-content new-task-modal ">
      <button class="new-task-modal__close" type="button" @click="$emit('close')">
        ✕
      </button>

      <div>
        <h2 class="new-task-modal__title">{{ taskDetail.source === 'planned' ? 'Запланированная задача' : 'Прошедшая задача'}}</h2>

        <div class="task-color-wrapper">
          <div class="tasks_wrapper">
            <p class="header_green">Выбранная задача</p>
            <div class="select_wrapper">
              <multiselect
                  :disabled="true"
                  :options="taskOptions"
                  v-model="moodForm.task"
                  :allow-empty="false"
                  track-by="id" label="text"
                  aria-label="Выберите задачу"
                  placeholder="Выберите задачу"
                  selectedLabel="Выбрано"
                  deselectLabel=""
                  selectLabel=""
                  name="trigger_list"
              >
                <template #noOptions>
                  Список загружается...
                </template>
              </multiselect>
            </div>
          </div>

          <ul class="color_list" v-if="taskDetail.already_happened">
            <li v-for="(value, key) in colorsMap" :key="key">
              <div class="mood_color_block" :class="[{'active': value === activeColor}, key]"></div>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="recommendationsLoaded && taskDetail.already_happened" class="recommendation-resume">
        <div v-if="moodForm.color_id && appropriateMood" class='assessed_mood_wrapper'>
          <div>
            Вы в подходящем состоянии для этой задачи. Используйте его эффективно.
          </div>
        </div>
        <div v-else class="recommendation-resume">
          <p>Ваше состояние не способствовало решению данной задачи</p>
          <p v-if="mismatchRecommendation">
            {{ mismatchRecommendation }}
          </p>
        </div>
      </div>

      <div class="task-detail-time"> {{ taskDetail.is_today_expected ? 'Сегодня' :  taskDetail.date.split('-').reverse().join('.') }} {{ taskDetail.interval }}</div>

      <div v-if="taskDetail.feedback" class="task-rating">

        <div>
          <task-scores :successfulRate="taskDetail.feedback.successful_rate" :effectiveRate="taskDetail.feedback.effective_rate" />
        </div>
        <div v-if="taskDetail.feedback?.comment" class="feedback-comment">
          <span>Описание:</span> {{ taskDetail.feedback.comment }}
        </div>
      </div>

      <div v-else>
        <div v-if="taskDetail?.comment">
          <span>Описание:</span> {{ taskDetail.comment }}
        </div>
      </div>

      <div class="modal-control">
        <div class="modal-control-button">
          <button v-if="!taskDetail.already_happened" class="btn btn-close task-delete-button" @click="deleteTask">
            Удалить
          </button>

          <button class="btn btn-close" @click="$emit('close')">
            Закрыть
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BatteryIndicator from './BatteryIndicator.vue'
import {computed, reactive} from "@vue/reactivity";
import {useStore} from "vuex";
import CustomSelect from "@/components/Forms/Fields/CustomSelect.vue";
import {onBeforeMount, ref} from "@vue/runtime-core";
import Multiselect from "vue-multiselect";
import TaskSchedulePicker from "@/views/MoodTracker/MoodTrackerTaskSchedule.vue";
import CustomTextarea from "@/components/Forms/Fields/CustomTextarea.vue";
import CustomRadio from "@/components/Forms/Fields/CustomRadio.vue";
import {notify} from "@kyvg/vue3-notification";
import MiniPreloader from "@/components/Technical/MiniPreloader.vue";
import StrategyModal from "@/views/MoodTracker/MoodTrackerStrategyModal.vue";
import textCard from "@/views/MoodTracker/colorCardText";
import TaskScores from "@/views/MoodTracker/MoodTrackerTaskScores.vue";
import {task} from "@vue/cli-plugin-eslint/ui/taskDescriptor";

export default {
  name: 'MoodTrackerTaskReview',
  computed: {
    task() {
      return task
    }
  },
  components: {
    TaskScores,
    StrategyModal,
    MiniPreloader,
    CustomRadio,
    CustomTextarea,
    TaskSchedulePicker,
    Multiselect,
    CustomSelect,
    BatteryIndicator,
  },
  emits: ['close', 'deleted'],
  props: {
    taskDetail: {
      type: Object,
    },
  },
  setup(props, context) {
    const store = useStore();
    const currentSettings = computed(() => store.state.tracker.settingsData);
    const batteryResetInterval = ref('weekly');
    const taskOptions = ref([]);
    const isLoading = ref(false);
    const isTaskSet = ref(false);
    const activeColor = ref('');
    const currentOccurredTask =  computed(() => store.state.tracker.currentOccurredTask);
    const recommendationsLoaded = ref(false);

    const moodForm = reactive({
      color_id: null,
      task_id: null,
      task: null,
      feedback_interval: null,
      schedule: {
        date: null,
        task_interval: null,
        repeat_type: null,
        comment: null,
      }
    });

    const colorList = computed(() => store.state.tracker.colorList);
    const taskList = computed(() => store.state.tracker.taskList);

    const colorsMap = {
      red: 'Красный',
      yellow: 'Жёлтый',
      blue: 'Синий',
      green: 'Зелёный',
    };

    onBeforeMount(async () => {
      isLoading.value = true;

      if (props.taskDetail) {
        setPlannedTaskForm();
      }
    });

    const setPlannedTaskForm = () => {
      let taskData = taskList.value.find((el) => el.id === props.taskDetail.task.id);
      let date = props.taskDetail.interval.split('-');

      moodForm.task_id = props.taskDetail.task_id;
      moodForm.task = {id: taskData.id, text: taskData.task}
      moodForm.schedule.date = props.taskDetail.date;
      moodForm.schedule.start_time = date[0];
      moodForm.schedule.end_time = date[1];
      moodForm.schedule.task_interval = props.taskDetail.interval;
      moodForm.schedule.comment = props.taskDetail.comment;

      if (props.taskDetail.already_happened) {
        activeColor.value = props.taskDetail.color.name;
        moodForm.task_id = props.taskDetail.color.id;
        getRecommendation();
        recommendationsLoaded.value = true;
      }
    }

    const appropriateMood = ref();
    const recommendedColorEntity = ref(null);
    const mismatchText = ref();
    const mismatchRecommendation = ref();
    const recommendedColor = ref('');

    const getRecommendation = () => {
      let taskColor = taskList.value.find((el) => el.id === parseInt(moodForm.task.id));
      recommendedColorEntity.value = colorList.value.find((el) => el.id === parseInt(taskColor.color_id));
      let recommendedColorKey = Object.keys(colorsMap).find(key => colorsMap[key] === recommendedColorEntity.value.name);

      recommendedColor.value = recommendedColorEntity.value.name;
      mismatchRecommendation.value = textCard[recommendedColorKey].mismatch_recommendation;

      appropriateMood.value = moodForm.color_id === taskColor.color_id;
    }

    const deleteTask = () => {
      store.dispatch('tracker/deletePlannedTask', {id: props.taskDetail.planned_task_id}).then(() => {
        notify({
          type: "info",
          title: "Задача удалена"
        });

        context.emit('deleted');
      });
    }

    return {
      currentSettings,
      batteryResetInterval,
      moodForm,
      taskOptions,
      isTaskSet,
      colorsMap,
      activeColor,
      appropriateMood,
      mismatchText,
      recommendationsLoaded,
      mismatchRecommendation,
      currentOccurredTask,
      recommendedColorEntity,
      deleteTask
    }
  },
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  overflow-y: auto;
  display: flex;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.new-task-modal {
  position: relative;
  width: 900px;
  max-width: 100%;
  background: #f3f3f3;
  border-radius: 26px;
  padding: 26px 34px 28px;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
  margin: auto 0;
}

.new-task-modal .form-group {
  font-size: 16px;
  font-weight: 600;
}

@media (min-width: 901px) {
  .modal-backdrop {
    align-items: center;
  }
}

@media (max-width: 900px) {
  .modal-backdrop {
    align-items: flex-start;
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .new-task-modal {
    margin: 0;
    border-radius: 20px;
  }
}

.new-task-modal__close {
  position: absolute;
  top: 18px;
  right: 18px;
  border: none;
  background: transparent;
  font-size: 28px;
  line-height: 1;
  color: #8f8f8f;
  cursor: pointer;
  padding: 0;
}

.new-task-modal__title {
  margin: 0 0 18px;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
}

.tasks_wrapper .form-group {
  justify-content: flex-start;
}

.header_green {
  font-size: 18px;
  font-weight: bold;
  color: #51bb50;
}

.select_wrapper {
  margin: 10px 0;

  @media (max-width: 900px) {
    width: 100%;
  }
}

.schedule-wrapper {
  margin: 30px 0;

  p {
    margin-bottom: 15px;
  }

  .form-group {
    font-size: 14px;
    margin-top: 0;
  }
}

.modal-control {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;

  .btn {
    border-radius: 6px;
  }
}

.color_list {
  margin: 20px 0;
  display: flex;
  column-gap: 10px;
}

.mood_color_block {
  width: 60px;
  height: 80px;
  cursor: pointer;
  position: relative;
}

.mood_color_block:hover {
  opacity: 0.9;
}

.mood_color_block.yellow {
  background-image: linear-gradient(rgba(255, 236, 138, 0.6), rgba(255, 236, 138, 0.6)), url("../../assets/images/yellow-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #ffec8a;
}

.mood_color_block.green {
  background-image: linear-gradient(rgba(176, 220, 156, 0.6), rgba(176, 220, 156, 0.6)), url("../../assets/images/green-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #b0dc9c;
}

.mood_color_block.blue {
  background-image: linear-gradient(rgba(130, 152, 204, 0.6), rgba(130, 152, 204, 0.6)), url("../../assets/images/blue-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #8298cc;
}

.mood_color_block.red {
  background-image: linear-gradient(rgba(242, 145, 117, 0.6), rgba(242, 145, 117, 0.6)), url("../../assets/images/red-card.png");
  background-size: cover;
  background-position: center;
  border: 3px solid #f29175;
}

.color_text {
  font-weight: bold;
}

.text_yellow {
  color: #ffec8a;
}

.text_green {
  color: #b0dc9c;
}

.text_blue {
  color: #8298cc;
}

.text_red {
  color: #f29175;
}

.active::after {
  content: "✓";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 80px;
  color: #00e287;
  pointer-events: none;
}

.red.active {
  background-image: url("../../assets/images/mood_tracker/red.svg");
}

.green.active {
  background-image: url("../../assets/images/mood_tracker/green.svg");
}

.blue.active {
  background-image: url("../../assets/images/mood_tracker/blue.svg");
}

.yellow.active {
  background-image: url("../../assets/images/mood_tracker/yellow.svg");
}

.task-color-wrapper {
  display: flex;
  gap: 16px;
  justify-content: space-between;

  @media (max-width: 930px) {
    flex-direction: column;
  }
}

.assessed_mood_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  padding: 20px;

  @media (max-width: 900px) {
    padding: 20px 0;
  }
}

.save_button_wrapper {
  display: flex;
  justify-content: end;
  padding: 10px 20px;
}

.recommendation_wrapper {
  display: flex;
  column-gap: 15px;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 700px) {
    flex-direction: column;
    gap: 16px;
  }
}

.mood_recommendation {
  display: flex;
  flex-direction: column;
  padding: 20px;
  row-gap: 20px;
  width: 48%;
  min-height: 350px;
  font-size: 16px;
  background-color: #ffffff;
  border-radius: 8px;
  justify-content: space-between;

  @media (max-width: 700px) {
    width: 100%;
  }
}

.mini-loader {
  text-align: center;
  padding: 40px 0;
}

.planned-task-text {
  margin-bottom: 16px;
  font-size: 18px;
  text-align: center;

  b {
    font-weight: bold;
  }
}

.planned-list.color_list {
  justify-content: center;
}

:deep(.multiselect--disabled .multiselect__select) {
  background-color: #ffffff;
}

.task-detail-time {
  margin: 25px 0;
}

.btn.task-delete-button {
  border-radius: 16px;
  font-weight: 600;
  color: #ffffff;
  background-color: #dd6659;
  border-color: #dc6458;
}

.task-delete-button:hover {
  background-color: #dd6659;
  border-color: #dc6458;
  opacity: 0.9;
}

.task-rating {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.recommendation-resume {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.feedback-comment {
  margin-top: 25px;
}
</style>